import {
  PersonAdd as AddUserIcon,
  Login as LoginIcon,
  Settings,
  GridView as UserGridIcon,
} from "@mui/icons-material";
import SpeedIcon from '@mui/icons-material/Speed';
import SessionsIcon from "./Sessions";
import UserManagementIcon from "./UserManagement";
import UserProfileIcon from "./UserProfile";
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';

//new icons
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import BarChartOutlinedIcon from "@mui/icons-material/BarChartOutlined";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import MapOutlinedIcon from "@mui/icons-material/MapOutlined";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import PieChartOutlineOutlinedIcon from "@mui/icons-material/PieChartOutlineOutlined";
import TimelineOutlinedIcon from "@mui/icons-material/TimelineOutlined";
import { Money } from "@mui/icons-material";
//import logo from "../../assets/user.png";

import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import BalanceIcon from "@mui/icons-material/Balance";
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import DriveFolderUploadIcon from "@mui/icons-material/DriveFolderUpload";
import GroupsIcon from "@mui/icons-material/Groups";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import PaidIcon from "@mui/icons-material/Paid";
import PhoneAndroidIcon from "@mui/icons-material/PhoneAndroid";
import SavingsIcon from "@mui/icons-material/Savings";
import SmsIcon from "@mui/icons-material/Sms";
//import SpaceDashboardIcon from "@mui/icons-material/SpaceDashboard";
import StackedLineChartIcon from "@mui/icons-material/StackedLineChart";
//new icons

//Dashboard Sidebar Icons
import HomeIcon from '@mui/icons-material/Home';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';

import Agriculture from '@mui/icons-material/Agriculture';
import GradeIcon from '@mui/icons-material/Grade';
import GrainIcon from '@mui/icons-material/Grain';
import PriceChangeIcon from '@mui/icons-material/PriceChange';
import AddBusinessIcon from '@mui/icons-material/AddBusiness';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import FactoryIcon from '@mui/icons-material/Factory';
import InventoryIcon from '@mui/icons-material/Inventory';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import PaymentsIcon from '@mui/icons-material/Payments';
import CalculateIcon from '@mui/icons-material/Calculate';
import Diversity3Icon from '@mui/icons-material/Diversity3';
import ReceiptIcon from '@mui/icons-material/Receipt';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import DashboardCustomizeIcon from '@mui/icons-material/DashboardCustomize';
import FolderSharedIcon from '@mui/icons-material/FolderShared';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import AutoStoriesIcon from '@mui/icons-material/AutoStories';

import AssessmentIcon from "@mui/icons-material/Assessment";
import TableChartIcon from "@mui/icons-material/TableChart";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import AssignmentIcon from "@mui/icons-material/Assignment";

import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import PeopleIcon from '@mui/icons-material/People';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import HandshakeIcon from '@mui/icons-material/Handshake';

// eslint-disable-next-line import/no-anonymous-default-export
export default {

  HomeIcon,
  MonetizationOnIcon,
  RequestQuoteIcon,
  
  LoginIcon,
  AddUserIcon,
  SessionsIcon,
  UserGridIcon,
  SpeedIcon,
  UserProfileIcon,
  UserManagementIcon,
  PersonOutlinedIcon,
  CalendarTodayOutlinedIcon,
  HelpOutlineOutlinedIcon,
  BarChartOutlinedIcon,
  PieChartOutlineOutlinedIcon,
  TimelineOutlinedIcon,
  MenuOutlinedIcon,
  MapOutlinedIcon,
  EmojiEventsIcon,
  Money,
  //logo,
  //SpaceDashboardIcon,
  ConfirmationNumberIcon,
  GroupsIcon,
  PaidIcon,
  SavingsIcon,
  BalanceIcon,
  SmsIcon,
  PhoneAndroidIcon,
  AccountBalanceIcon,
  SupportAgentIcon,
  AccountBalanceWalletIcon,
  DriveFolderUploadIcon,
  StackedLineChartIcon,
  AdminPanelSettingsIcon,
  KeyboardArrowRightIcon,
  SupervisorAccountIcon,
  Settings,

  Agriculture,
  GradeIcon,
  GrainIcon,
  PriceChangeIcon,
  AddBusinessIcon,
  GroupAddIcon,
  FactoryIcon,
  InventoryIcon,
  AccountTreeIcon,
  PaymentsIcon,
  CalculateIcon,
  Diversity3Icon,
  ReceiptIcon,
  TrendingUpIcon,
  DashboardCustomizeIcon,
  FolderSharedIcon,
  LibraryBooksIcon,
  AutoStoriesIcon,

  AssessmentIcon,
  TableChartIcon,
  Inventory2Icon,
  AssignmentIcon,
  LocalShippingIcon,
  PeopleIcon,
  ShoppingCartIcon,
  HandshakeIcon,

};


